import React from 'react';
import { BookOpen, Moon } from 'lucide-react';
import { siteContent } from '../data/mock';

const BonusSection = () => {
  const { bonus } = siteContent;
  const icons = { notebook: BookOpen, moon: Moon };

  return (
    <section className="bonus-section section-padding" data-testid="bonus-section" data-reveal="subtle">
      <div className="container">
        <div className="bonus-header">
          <h2 className="section-title-center" data-testid="bonus-title">{bonus.title}</h2>
          <p className="bonus-subtitle">{bonus.subtitle}</p>
        </div>

        <div className="bonus-grid">
          {bonus.items.map((item, index) => {
            const Icon = icons[item.icon] || BookOpen;
            return (
              <div key={index} className="content-card bonus-card" data-testid={`bonus-card-${index}`}>
                <div className="bonus-icon">
                  <Icon size={32} strokeWidth={1.5} />
                </div>
                <h3 className="bonus-card-title">{item.name}</h3>
                <p className="bonus-card-description">{item.description}</p>
              </div>
            );
          })}
        </div>

        <p className="bonus-note" data-testid="bonus-note">{bonus.note}</p>
      </div>
    </section>
  );
};

export default BonusSection;
